import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=1050854e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1050854e')) {
      api.createRecord('1050854e', component.options)
    } else {
      api.reload('1050854e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=1050854e&", function () {
      api.rerender('1050854e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29hq2vqokVewN/JS/comp/openstreetmap.vue"
export default component.exports